import React, { useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import daygridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import Event from "./Event";
import Popup from "reactjs-popup";
import { useEffect } from "react";
import isEmpty from "lodash/isEmpty";
import { saveEvents, fetchEvents } from "../../Redux/Actions/calendarAction";
import { connect } from "react-redux";
import { searchProspect } from "../../Redux/Actions/webAppActions";

const initialEvent = [
  {
    eventId: "",
    eventType: "",
    eventAddress: "",
    start: "",
    end: "",
    agentName: "",
    maxAttendees: "",
    appointmentConfimInd: "N",
    soaInd: "",
    note: "",
    phone: "",
    email: "",
    customerId: "",
    agentEmail: "",
  },
];
const EventColor = [
  { title: "Sales", color: "#947fb5" },
  { title: "Follow", color: "#3abd5d" },
  { title: "Prospect", color: "#10b5e3" },
];

const FullCalleder = (events, handleEvent, handleSelect, ref) => {
  return (
    <FullCalendar
      ref={ref}
      editable
      selectable
      aspectRatio={3}
      firstDay={1}
      nowIndicator={true}
      contentHeight={"auto"}
      events={events}
      eventClick={handleEvent}
      select={handleSelect}
      initialView="timeGridWeek"
      headerToolbar={{
        start: "today prev next",
        center: "title",
        end: "dayGridMonth timeGridWeek timeGridDay",
      }}
      timeZone="Europe/Paris"
      eventTimeFormat={{
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }}
      eventColor="green"
      allDaySlot={false}
      navLinks={true}
      longPressDelay={0}
      //overlap={ false}
      // slotMinTime="07:00:00"
      // slotMaxTime="21:00:00"
      slotMinTime="00:00:00"
      slotMaxTime="24:00:00"
      plugins={[timeGridPlugin, daygridPlugin, interactionPlugin]}
      views={[
        "dayGridMonth",
        "timeGridWeek",
        "timeGridDay",
        {
          day: {
            titleFormat: {
              month: "numeric",
              day: "numeric",
              weekday: "long",
            },
          },
        },
      ]}
    />
  );
};
const Calendar = (props) => {
  const [events, setEvents] = useState([]);
  const [popupFalg, setPop] = useState(false);
  const [info, setInfo] = useState("");
  const [eveData, setEveData] = useState(initialEvent[0]);
  const [ignore, setIgnore] = useState(false);
  const [change, setChange] = useState(new Date());
  const fullcalendar = useRef();
  const handleSelect = async (info1) => {
    setInfo(info1);
    setEveData(initialEvent[0]);
    setPop(true);
  };

  useEffect(() => {
    loadEvents();
  }, []);

 const loadEvents = async () =>{
    const { customerId, agentEmailId } = props.login;
    let payload = {
      emailId: agentEmailId,
      customerId: customerId,
    };
    await props.fetchEvents(payload);
    // if (isEmpty(props.prospectList)) {
      props.searchProspect({
        firstName: "",
        lastName: "",
        statusType: "",
        assignedTo: "",
        leadIdNbr: "",
        planCampaignId: "",
      });
    }

  useEffect(() => {
    handleEventColor(props.events);
  }, [change]);

  useEffect(() => {
    if (!isEmpty(props.events)) {
      handleEventColor(props.events);
    } else {
      setEvents(initialEvent);
    }

    setCalander();
  }, [props.events,props.token]);
  const setCalander = () => {
    setTimeout(() => {
      if(fullcalendar?.current!=null){
      fullcalendar.current.getApi().render();
      }
    }, 300);
  };

  const handleEventColor = async (eventData) => {
    let list = [];
    eventData.forEach((e) =>
      EventColor.forEach((c) => {
        if (e.eventType.includes(c.title)) {
          let propsName=!isEmpty(e.prospectName)?e.prospectName.label:''
          list.push({
            ...e,
            title:e.eventType.concat(`:${propsName}`),
            color: c.color,
          });
        }
      })
    );
    await setEvents([...list]);
    setIgnore(!ignore);
  };

  const handleSchedular = async (payload) => {
    let calendersave=await props.saveEvents(payload);
    if(calendersave.status==="OK"){
    loadEvents();
    }
    else{
      let msg="Error occured while saving"
      props.handleSnackbar(msg,"error")
    }
  };

  const handleEvent = async (eventClickInfo) => {
    const { extendedProps } = eventClickInfo.event._def;
    let obj = events.filter(
      (item) => item.eventId === extendedProps.eventId
    )[0];
   // await setEveData(obj);
    await setEveData((prev) => ({
      ...obj
    }));
    await setPop(true);
  };
  return (
    <>
      <div id="cal" className="calendraContain">
        {FullCalleder(events, handleEvent, handleSelect, fullcalendar)}
        <Popup
          className={"responsive-width pcp-popup"}
          modal
          open={popupFalg}
          onClose={() => setPop(false)}
          position="right center"
          repositionOnResize={true}
          contentStyle={{ width: "77% !important", padding: "0px"}}
        >
          {(close) => (
            <div style={{    overflowY: "scroll",
              height: "35rem",
              // position:"relative"
              }}>
              <Event
                close={close}
                info={info}
                saveEvents={handleSchedular}
                eveData={eveData}
                isSuperUser={props.isSuperUser}
                change={change}
                setChange={setChange}
                prospectList={props.prospectList}
                setCalander={setCalander}
              />
            </div>
          )}
        </Popup>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  saveEvents,
  fetchEvents,
  searchProspect,
};
const mapStateToProps = (state) => {
  return {
    events: state.calendar.events,
    login: state.login,
    isSuperUser: state.webApp.isSuperUser,
    isAgentRole: state.webApp.isAgentRole,
    prospectList: state.campaignProspect.prospectTableData,
    token:state.login.token,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
